import { onClickOutside } from '@vueuse/core'
import { nextTick, ref, type DirectiveBinding } from 'vue';
import type { ButtonElement, DropdownOptions } from './types';

async function positionMenu(el: ButtonElement) {
    await nextTick()
    const rect = el.getBoundingClientRect();
    const menu = el.nextElementSibling;

    if (!menu) { return; }

    if (menu?.classList.contains('dropdown-menu-left')
        || menu?.classList.contains('dropdown-menu-right')) {
        return;
    }

    const spaceRight = window.innerWidth - rect.right;
    const spaceLeft = rect.left;

    menu.classList.remove('dropdown-menu-left', 'dropdown-menu-right');

    if (spaceRight >= spaceLeft) {
        menu.classList.add('dropdown-menu-left');
    } else {
        menu.classList.add('dropdown-menu-right');
    }
}

export default {
    mounted(el: ButtonElement, binding: DirectiveBinding<DropdownOptions>) {
        const parent = el.parentNode as HTMLElement;
        const isOpen = ref(false);
        const stayOpen = binding.value?.stayOpen ?? false;

        const closeDropdown = () => {
            if (!isOpen.value) return;
            isOpen.value = false;

            if (binding.value?.dropdownState) {
                Object.assign(binding.value.dropdownState, { isOpen: false });
            }

            if (parent) {
                parent.classList.remove('open');
            }
        };

        const clickOutsideTarget = stayOpen ? parent : el;
        onClickOutside(clickOutsideTarget, closeDropdown);

        const onClick = async () => {
            const newState = stayOpen ? true : !isOpen.value;
            isOpen.value = newState;

            if (binding.value?.dropdownState) {
                Object.assign(binding.value.dropdownState, { isOpen: newState });
            }

            if (parent) {
                parent.classList.toggle('open', newState);
            }

            if (isOpen.value) {
                await positionMenu(el);
            }
        }

        el.addEventListener('click', onClick);

        el.cleanup = () => {
            el.removeEventListener('click', onClick);
        }
    },

    unmounted(el: ButtonElement) {
        el.cleanup?.();
        delete el.cleanup;
    }
}
